"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusAdvantagesLinksIconTypeEnum = exports.CustomerStatusAdvantagesLinksToJSON = exports.CustomerStatusAdvantagesLinksFromJSONTyped = exports.CustomerStatusAdvantagesLinksFromJSON = void 0;
var runtime_1 = require("../runtime");
function CustomerStatusAdvantagesLinksFromJSON(json) {
    return CustomerStatusAdvantagesLinksFromJSONTyped(json, false);
}
exports.CustomerStatusAdvantagesLinksFromJSON = CustomerStatusAdvantagesLinksFromJSON;
function CustomerStatusAdvantagesLinksFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': json['description'],
        'href': json['href'],
        'iconType': !(0, runtime_1.exists)(json, 'iconType') ? undefined : json['iconType'],
    };
}
exports.CustomerStatusAdvantagesLinksFromJSONTyped = CustomerStatusAdvantagesLinksFromJSONTyped;
function CustomerStatusAdvantagesLinksToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'href': value.href,
        'iconType': value.iconType,
    };
}
exports.CustomerStatusAdvantagesLinksToJSON = CustomerStatusAdvantagesLinksToJSON;
/**
* @export
* @enum {string}
*/
var CustomerStatusAdvantagesLinksIconTypeEnum;
(function (CustomerStatusAdvantagesLinksIconTypeEnum) {
    CustomerStatusAdvantagesLinksIconTypeEnum["Premium"] = "premium";
    CustomerStatusAdvantagesLinksIconTypeEnum["Credit"] = "credit";
})(CustomerStatusAdvantagesLinksIconTypeEnum = exports.CustomerStatusAdvantagesLinksIconTypeEnum || (exports.CustomerStatusAdvantagesLinksIconTypeEnum = {}));
//# sourceMappingURL=CustomerStatusAdvantagesLinks.js.map